<script setup lang="ts">
import { nextTick, onMounted, ref } from 'vue'

import SharedDialog from '../../../../../components/shared/Dialog.vue'
import { useKeepTabbingFocus } from '../../../../../composables/use-keep-tabbing-focus'

const emit = defineEmits<{
  'apply-filters': [],
  'discard-filters': [],
  'change-filters': []
}>()

const { keepTabbingFocus, removeTabbingEventListeners } = useKeepTabbingFocus()

const sharedDialog = ref<InstanceType<typeof SharedDialog> | null>(null)

const keepTabbingFocusInFilterDialog = () => {
  nextTick(() => {
    removeTabbingEventListeners()
    const dialogElement = sharedDialog.value?.$el as HTMLElement | undefined
    if (!dialogElement) return
    keepTabbingFocus(dialogElement, ['button'], 0, () => {
      removeTabbingEventListeners()
      emit('change-filters')
    })
  })
}

onMounted(keepTabbingFocusInFilterDialog)
</script>

<template>
  <SharedDialog ref="sharedDialog"
                title="Filteränderungen nicht übernommen"
                @close="$emit('change-filters')">
    <template #header>
      <div class="bx-dialog__title">
        <h2>Filteränderungen nicht übernommen</h2>
      </div>
    </template>

    <div class="bx-content__continuous-text bx-typo--content-continuous-text bx-typo--center">
      <p>
        Du hast deine Filter geändert, aber noch nicht angewendet.<br>
        Möchtest du die Änderungen jetzt anwenden oder verwerfen?
      </p>
    </div>

    <form class="bx-form bx-typo--form">
      <div class="bx-form__item bx-form__item--centered">
        <button class="bx-form__button bx-form__button--secondary"
                type="button"
                @click.prevent="$emit('discard-filters')">
          Änderungen verwerfen
        </button>
        <button type="button"
                class="bx-form__button"
                @click="$emit('apply-filters')">
          Filter anwenden
        </button>
      </div>
    </form>
  </SharedDialog>
</template>
